<div class="login-inside-container" id="div_login-inside-container_ae6e90d7">
  <h1 title="Success" aria-label="Success" id="h1_ca88aeff">Success!</h1>
  <label id="label_e5a3a79c"
    >Your password was successfully updated. Please sign in to begin searching
    railcar inventory.</label
  >
  <div class="btn-panel" id="div_btn-panel_38df4907">
    <button
      aria-label="Return to sign in"
      class="next-button"
      (click)="backToLogin()"
      id="button_next-button_b17c8753"
    >
      Return to sign in
    </button>
  </div>
</div>
